import React from 'react';

// componenets
import CardTitlePart from '../../parts/CardTitlePart';

const ErrorCard = ({
  error, // payload
  bodyText, image // template value
}) => (
  <div>

    <CardTitlePart title={error} />
    <img alt="probably a cat" src={image} />
    {bodyText}

  </div>
);


export default ErrorCard;



// WEBPACK FOOTER //
// ./src/cards/templates/ErrorCard.js